var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVideoOff = function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "video-off_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#video-off_svg__a)",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10M1 1l22 22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "video-off_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};

export { SvgVideoOff as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTEwNl8xNjUzOSkiPjxwYXRoIGQ9Ik0xNiAxNlYxN0MxNiAxNy41MzA0IDE1Ljc4OTMgMTguMDM5MSAxNS40MTQyIDE4LjQxNDJDMTUuMDM5MSAxOC43ODkzIDE0LjUzMDQgMTkgMTQgMTlIM0MyLjQ2OTU3IDE5IDEuOTYwODYgMTguNzg5MyAxLjU4NTc5IDE4LjQxNDJDMS4yMTA3MSAxOC4wMzkxIDEgMTcuNTMwNCAxIDE3VjdDMSA2LjQ2OTU3IDEuMjEwNzEgNS45NjA4NiAxLjU4NTc5IDUuNTg1NzlDMS45NjA4NiA1LjIxMDcxIDIuNDY5NTcgNSAzIDVINU0xMC42NiA1SDE0QzE0LjUzMDQgNSAxNS4wMzkxIDUuMjEwNzEgMTUuNDE0MiA1LjU4NTc5QzE1Ljc4OTMgNS45NjA4NiAxNiA2LjQ2OTU3IDE2IDdWMTAuMzRMMTcgMTEuMzRMMjMgN1YxNyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0iTTEgMUwyMyAyMyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iY2xpcDBfNTEwNl8xNjUzOSI+PHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4=";